import { isNative } from './platform';

export async function hapticFeedback(style = 'medium') {
  if (!isNative) return;
  const { Haptics, ImpactStyle } = await import('@capacitor/haptics');
  const styles = { light: ImpactStyle.Light, medium: ImpactStyle.Medium, heavy: ImpactStyle.Heavy };
  await Haptics.impact({ style: styles[style] || ImpactStyle.Medium });
}

export async function hapticNotification(type = 'success') {
  if (!isNative) return;
  const { Haptics, NotificationType } = await import('@capacitor/haptics');
  const types = { success: NotificationType.Success, warning: NotificationType.Warning, error: NotificationType.Error };
  await Haptics.notification({ type: types[type] || NotificationType.Success });
}


export async function setupKeyboardListeners(onShow, onHide) {
  if (!isNative) return () => {};
  const { Keyboard } = await import('@capacitor/keyboard');
  const showListener = await Keyboard.addListener('keyboardWillShow', onShow);
  const hideListener = await Keyboard.addListener('keyboardWillHide', onHide);
  return () => { showListener.remove(); hideListener.remove(); };
}
